/**
 * @flow
 * @relayHash 6cecf62ea38c86cf00b6971f84852fe7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type EventShowContainer_node$ref = any;
export type EventShowContainer_RefetchQueryVariables = {|
  id: string
|};
export type EventShowContainer_RefetchQueryResponse = {|
  +node: ?{|
    +$fragmentRefs: EventShowContainer_node$ref
  |}
|};
export type EventShowContainer_RefetchQuery = {|
  variables: EventShowContainer_RefetchQueryVariables,
  response: EventShowContainer_RefetchQueryResponse,
|};
*/


/*
query EventShowContainer_RefetchQuery(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ...EventShowContainer_node
    id
  }
}

fragment EventShowContainer_node on Event {
  id
  start_at
  end_at
  all_day
  time_zone
  title
  can_edit
  user_event {
    id
    booking_status
    visibility
    start_at
    end_at
    time_zone
  }
  workspaces(first: 99999) {
    edges {
      node {
        id
        title
        contracts(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        estimates(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        forms(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        invoices(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        music_planners(first: 99999) {
          edges {
            node {
              id
              title
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...EventSummaryContainer_node
}

fragment EventSummaryContainer_node on Event {
  id
  user_event {
    id
    notes
    referral_source
    ...ScheduleContainer_node
  }
  user_contacts(first: 99999) {
    edges {
      id
      role
      node {
        id
        first_name
        last_name
        company_name
        user_contact_addresses(first: 99999) {
          edges {
            node {
              id
              label
              line1
              line2
              city
              province
              postal_code
              country
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        user_contact_emails(first: 99999) {
          edges {
            node {
              id
              label
              address
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        user_contact_phones(first: 99999) {
          edges {
            node {
              id
              label
              number
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ScheduleContainer_node on UserEvent {
  id
  user_event_segments(first: 99999) {
    edges {
      node {
        id
        title
        start_at
        end_at
        time_zone
        all_day
        location
        line1
        line2
        city
        province
        postal_code
        room
        notes
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "start_at",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "end_at",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "all_day",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "time_zone",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "notes",
  "args": null,
  "storageKey": null
},
v10 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }
],
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "line1",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "line2",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "city",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "province",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "postal_code",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v18 = [
  v3,
  v8,
  v2
],
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "EventShowContainer_RefetchQuery",
  "id": null,
  "text": "query EventShowContainer_RefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...EventShowContainer_node\n    id\n  }\n}\n\nfragment EventShowContainer_node on Event {\n  id\n  start_at\n  end_at\n  all_day\n  time_zone\n  title\n  can_edit\n  user_event {\n    id\n    booking_status\n    visibility\n    start_at\n    end_at\n    time_zone\n  }\n  workspaces(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        contracts(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        estimates(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        forms(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        invoices(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        music_planners(first: 99999) {\n          edges {\n            node {\n              id\n              title\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...EventSummaryContainer_node\n}\n\nfragment EventSummaryContainer_node on Event {\n  id\n  user_event {\n    id\n    notes\n    referral_source\n    ...ScheduleContainer_node\n  }\n  user_contacts(first: 99999) {\n    edges {\n      id\n      role\n      node {\n        id\n        first_name\n        last_name\n        company_name\n        user_contact_addresses(first: 99999) {\n          edges {\n            node {\n              id\n              label\n              line1\n              line2\n              city\n              province\n              postal_code\n              country\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        user_contact_emails(first: 99999) {\n          edges {\n            node {\n              id\n              label\n              address\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        user_contact_phones(first: 99999) {\n          edges {\n            node {\n              id\n              label\n              number\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ScheduleContainer_node on UserEvent {\n  id\n  user_event_segments(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        start_at\n        end_at\n        time_zone\n        all_day\n        location\n        line1\n        line2\n        city\n        province\n        postal_code\n        room\n        notes\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "EventShowContainer_RefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "EventShowContainer_node",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "EventShowContainer_RefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          v2,
          v3,
          {
            "kind": "InlineFragment",
            "type": "Event",
            "selections": [
              v4,
              v5,
              v6,
              v7,
              v8,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "can_edit",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_event",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEvent",
                "plural": false,
                "selections": [
                  v3,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "booking_status",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "visibility",
                    "args": null,
                    "storageKey": null
                  },
                  v4,
                  v5,
                  v7,
                  v9,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "referral_source",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user_event_segments",
                    "storageKey": "user_event_segments(first:99999)",
                    "args": v10,
                    "concreteType": "UserEventSegmentConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserEventSegmentEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserEventSegment",
                            "plural": false,
                            "selections": [
                              v11,
                              v3,
                              v4,
                              v5,
                              v7,
                              v6,
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "location",
                                "args": null,
                                "storageKey": null
                              },
                              v8,
                              v12,
                              v13,
                              v14,
                              v15,
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "room",
                                "args": null,
                                "storageKey": null
                              },
                              v9,
                              v2
                            ]
                          },
                          v16
                        ]
                      },
                      v17
                    ]
                  },
                  {
                    "kind": "LinkedHandle",
                    "alias": null,
                    "name": "user_event_segments",
                    "args": v10,
                    "handle": "connection",
                    "key": "ScheduleContainer_user_event_segments",
                    "filters": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "workspaces",
                "storageKey": "workspaces(first:99999)",
                "args": v10,
                "concreteType": "WorkspaceConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WorkspaceEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Workspace",
                        "plural": false,
                        "selections": [
                          v3,
                          v8,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "contracts",
                            "storageKey": "contracts(first:99999)",
                            "args": v10,
                            "concreteType": "ContractConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ContractEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Contract",
                                    "plural": false,
                                    "selections": v18
                                  },
                                  v16
                                ]
                              },
                              v17
                            ]
                          },
                          {
                            "kind": "LinkedHandle",
                            "alias": null,
                            "name": "contracts",
                            "args": v10,
                            "handle": "connection",
                            "key": "EventShowContainer_contracts",
                            "filters": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "estimates",
                            "storageKey": "estimates(first:99999)",
                            "args": v10,
                            "concreteType": "EstimateConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "EstimateEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Estimate",
                                    "plural": false,
                                    "selections": v18
                                  },
                                  v16
                                ]
                              },
                              v17
                            ]
                          },
                          {
                            "kind": "LinkedHandle",
                            "alias": null,
                            "name": "estimates",
                            "args": v10,
                            "handle": "connection",
                            "key": "EventShowContainer_estimates",
                            "filters": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "forms",
                            "storageKey": "forms(first:99999)",
                            "args": v10,
                            "concreteType": "FormConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FormEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Form",
                                    "plural": false,
                                    "selections": v18
                                  },
                                  v16
                                ]
                              },
                              v17
                            ]
                          },
                          {
                            "kind": "LinkedHandle",
                            "alias": null,
                            "name": "forms",
                            "args": v10,
                            "handle": "connection",
                            "key": "EventShowContainer_forms",
                            "filters": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "invoices",
                            "storageKey": "invoices(first:99999)",
                            "args": v10,
                            "concreteType": "InvoiceConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "InvoiceEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Invoice",
                                    "plural": false,
                                    "selections": v18
                                  },
                                  v16
                                ]
                              },
                              v17
                            ]
                          },
                          {
                            "kind": "LinkedHandle",
                            "alias": null,
                            "name": "invoices",
                            "args": v10,
                            "handle": "connection",
                            "key": "EventShowContainer_invoices",
                            "filters": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "music_planners",
                            "storageKey": "music_planners(first:99999)",
                            "args": v10,
                            "concreteType": "MusicPlannerConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "MusicPlannerEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "MusicPlanner",
                                    "plural": false,
                                    "selections": v18
                                  },
                                  v16
                                ]
                              },
                              v17
                            ]
                          },
                          {
                            "kind": "LinkedHandle",
                            "alias": null,
                            "name": "music_planners",
                            "args": v10,
                            "handle": "connection",
                            "key": "EventShowContainer_music_planners",
                            "filters": null
                          },
                          v2
                        ]
                      },
                      v16
                    ]
                  },
                  v17
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "workspaces",
                "args": v10,
                "handle": "connection",
                "key": "EventShowContainer_workspaces",
                "filters": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user_contacts",
                "storageKey": "user_contacts(first:99999)",
                "args": v10,
                "concreteType": "EventUserContactConnectionWithRole",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "EventUserContactEdge",
                    "plural": true,
                    "selections": [
                      v3,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "role",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserContact",
                        "plural": false,
                        "selections": [
                          v3,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "first_name",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "last_name",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "company_name",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user_contact_addresses",
                            "storageKey": "user_contact_addresses(first:99999)",
                            "args": v10,
                            "concreteType": "UserContactAddressConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserContactAddressEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UserContactAddress",
                                    "plural": false,
                                    "selections": [
                                      v3,
                                      v19,
                                      v11,
                                      v12,
                                      v13,
                                      v14,
                                      v15,
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "country",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      v2
                                    ]
                                  },
                                  v16
                                ]
                              },
                              v17
                            ]
                          },
                          {
                            "kind": "LinkedHandle",
                            "alias": null,
                            "name": "user_contact_addresses",
                            "args": v10,
                            "handle": "connection",
                            "key": "EventSummaryContainer_user_contact_addresses",
                            "filters": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user_contact_emails",
                            "storageKey": "user_contact_emails(first:99999)",
                            "args": v10,
                            "concreteType": "UserContactEmailConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserContactEmailEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UserContactEmail",
                                    "plural": false,
                                    "selections": [
                                      v3,
                                      v19,
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "address",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      v2
                                    ]
                                  },
                                  v16
                                ]
                              },
                              v17
                            ]
                          },
                          {
                            "kind": "LinkedHandle",
                            "alias": null,
                            "name": "user_contact_emails",
                            "args": v10,
                            "handle": "connection",
                            "key": "EventSummaryContainer_user_contact_emails",
                            "filters": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user_contact_phones",
                            "storageKey": "user_contact_phones(first:99999)",
                            "args": v10,
                            "concreteType": "UserContactPhoneConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserContactPhoneEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "UserContactPhone",
                                    "plural": false,
                                    "selections": [
                                      v3,
                                      v19,
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "number",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      v2
                                    ]
                                  },
                                  v16
                                ]
                              },
                              v17
                            ]
                          },
                          {
                            "kind": "LinkedHandle",
                            "alias": null,
                            "name": "user_contact_phones",
                            "args": v10,
                            "handle": "connection",
                            "key": "EventSummaryContainer_user_contact_phones",
                            "filters": null
                          },
                          v2
                        ]
                      },
                      v16
                    ]
                  },
                  v17
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "user_contacts",
                "args": v10,
                "handle": "connection",
                "key": "EventSummaryContainer_user_contacts",
                "filters": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '044cdaf517eb4d18aea569bffd495718';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/__generated__/EventShowContainer_RefetchQuery.graphql.js